import { combineReducers } from "redux";

import LayoutReducer from "./layouts/reducer";

import DashboardReducer from "./Dashboard/dashboardWidgetDataSlice";
import UserDetailsReducer from "./UserDeatils/dashboardWidgetDataSlice";

import GetAllClientsReducer from "./ManageClient/getAllClientSlice";
import GetClientDetailsReducer from "./ManageClient/getClientDetailSlice";

import GetComplianceListReducer from "./ManageCompliance/getComplianceListSlice";

import GetCCFPointListReducer from "../slices/ManageCCFPoints/getCCFPointsSlice";

import getCCFFilterListSlice from "../slices/ManageCCFPoints/getCCFFilterListSlice";
import getCCFPointDetailSlice from "../slices/ManageCCFPoints/getCCFPointDetailSlice";
import getProjectCErtificationSlice from "../slices/ManageClient/getProjectCertificationSLice";
import manageComplianceReducer from "../slices/ManageCompliance/manageComplianceSlice";


import SupportTicketsReducer from "./GetSupportTickets/reducer";
import SupportTicketDetailsReducer from "./GetSupportTicketDetails/reducer";

import LicenseListReducer from "./LicenseList/reducer";

import FrameworksListReducer from "./Dhanush/ManageFrameworks/reducer";

const rootReducer = combineReducers({
    Layout: LayoutReducer,
    Dashboard: DashboardReducer,
    UserDetails: UserDetailsReducer,
    GetAllClients: GetAllClientsReducer,
    GetClientDetails: GetClientDetailsReducer,
    GetComplianceList: GetComplianceListReducer,
    GetCCFPointList: GetCCFPointListReducer,

    manageCompliance: manageComplianceReducer,
    getCCFPointDetailSlice,
    getCCFFilterListSlice,
    getProjectCErtificationSlice,

    SupportTickets: SupportTicketsReducer,
    SupportTicketDetails: SupportTicketDetailsReducer,

    LicenseList: LicenseListReducer,


    FrameworksList: FrameworksListReducer,
});

export default rootReducer;